module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/extend.js
// module id = 1017
// module chunks = 25